import { Box, Stack } from "@mui/material";
import React from "react";
import { formBuilderParams } from "../FormBuilder";

/**
 * @param {Object} props
 * @param {number} props.itemsPerRow
 * @param {React.ReactNode | React.ReactNode[]} props.children
 */
const FormBuilderRow = ({ itemsPerRow = 3, children }) => {
  const childrenList = Array.isArray(children) ? [...children.flat()] : [children];
  /** @type {React.ReactNode[][]} */
  const childrenNestedList = childrenList.reduce((nestedList, _, i) => {
    if (i % itemsPerRow === 0)
      nestedList.push(childrenList.slice(i, i + itemsPerRow));
    return nestedList;
  }, []);

  return (
    <>
      {childrenNestedList.map((row, i) => (
        <Stack
          key={i}
          direction="row"
          alignItems="center"
          gap={formBuilderParams.formItemRowGap}
        >
          {row.length === itemsPerRow
            ? row
            : [
              ...row,
              ...Array.from({ length: itemsPerRow - row.length }, (_, i) => (
                <Box key={i} sx={{ ...formBuilderParams.formItemStyle }} />
              )),
            ]}
        </Stack>
      ))}
    </>
  );
};

export default React.memo(FormBuilderRow);
